import { t } from '@lingui/core/macro'
import { DatePicker, Input, Tooltip } from 'antd'
import type { Dayjs } from 'dayjs'
import { useState } from 'react'
import { FaCalendar } from 'react-icons/fa6'

export type DateInputShellProps = {
  text: string
  onTextChange: (next: string) => void
  onCommit: () => void
  onRevert: () => void
  error: boolean
  popoverPicker: 'date' | 'year'
  popoverValue: Dayjs | null
  onPopoverChange: (value: Dayjs | null) => void
  placeholder?: string
  disabled?: boolean
  allowClear?: boolean
  status?: 'error' | 'warning'
  size?: 'small' | 'middle' | 'large'
  id?: string
  className?: string
}

export function DateInputShell(props: DateInputShellProps) {
  const {
    text,
    onTextChange,
    onCommit,
    onRevert,
    error,
    popoverPicker,
    popoverValue,
    onPopoverChange,
    placeholder,
    disabled,
    allowClear,
    status,
    size,
    id,
    className,
  } = props

  const [popoverOpen, setPopoverOpen] = useState(false)
  const effectiveStatus = error ? 'error' : status

  return (
    <Tooltip title={error ? t`Ungültiges Datum` : ''} open={error ? undefined : false}>
      <Input
        id={id}
        className={className}
        size={size}
        disabled={disabled}
        allowClear={allowClear}
        status={effectiveStatus}
        placeholder={placeholder}
        value={text}
        onChange={e => onTextChange(e.target.value)}
        onBlur={onCommit}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault()
            onCommit()
          } else if (e.key === 'Escape') {
            e.preventDefault()
            onRevert()
          }
        }}
        suffix={
          <span className="relative inline-flex items-center">
            <button
              type="button"
              disabled={disabled}
              aria-label={t`Kalender öffnen`}
              onClick={() => setPopoverOpen(true)}
              className="flex items-center px-1 text-gray-500 hover:text-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <FaCalendar />
            </button>
            <DatePicker
              picker={popoverPicker}
              open={popoverOpen}
              onOpenChange={setPopoverOpen}
              value={popoverValue}
              onChange={value => {
                onPopoverChange(value)
                setPopoverOpen(false)
              }}
              allowClear={false}
              suffixIcon={null}
              inputReadOnly
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                opacity: 0,
                pointerEvents: 'none',
                padding: 0,
                border: 0,
              }}
            />
          </span>
        }
      />
    </Tooltip>
  )
}
